<template>
  <modal 
    name="winner-lots-edit"
    @closed="$emit('updateComparisonData')"
    @before-open="handleBeforeOpen"
    style="z-index: 1001;"
  >
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Չափաբաժինների տվյալների մուտքագրում</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('winner-lots-edit')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <div class="row">
        <div class="col-md-12">
          <table class="table m-0" style="border-collapse: collapse; border-spacing: 0; width: 100% !important;;">
            <thead>
              <tr>
                <th style="width: 120px;">Չ/Հ</th>
                <th>CPV կոդ</th>
                <th>Անվանում</th>
                <th>Ապրանքային նշանը</th>
                <th>Մակնիշը</th>
                <th>Արտադրողի անվանումը</th>
                <th>Տեխնիկական բնութագիր հայերեն</th>
                <th>Տեխնիկական բնութագիր ռուսերեն</th>
              </tr>
            </thead>
            <tbody id="comparison-table" style="min-height: 5vh; max-height: 40vh!important; overflow: scroll">
              <template v-for="(lot, lotIndex) in participantGroup.won_lots">
                <tr :key="lotIndex">
                  <td>{{ lot.view_id }}</td>
                  <td>{{ lot.winner_lot_cpv_code }}{{ lot.procurement_plan.cpv_drop && '/'}}{{lot.procurement_plan.cpv_drop }}</td>
                  <td v-if="lot.is_from_outside">
                    <input
                      v-model="lot.winner_lot_cpv_name"
                      name="name"
                      type="text"
                      class="form-control"
                    >
                  </td>
                  <td v-else>
                    <input
                      v-model="lot.winner_lot_cpv_name"
                      name="name"
                      type="text"
                      class="form-control"
                    >
                  </td>
                  <td>
                    <input
                      v-if="currentOrganized.cpv_type !== '2'"
                      v-model="lot.winner_lot_trademark"
                      name="name"
                      type="text"
                      class="form-control"
                    >
                  </td>
                  <td>
                    <input
                      v-if="currentOrganized.cpv_type !== '2'"
                      v-model="lot.winner_lot_brand"
                      name="name"
                      type="text"
                      class="form-control"
                    >
                  </td>
                  <td>
                    <input
                      v-if="currentOrganized.cpv_type !== '2'"
                      v-model="lot.winner_lot_manufacturer"
                      name="name"
                      type="text"
                      class="form-control"
                    >
                  </td>
                  <td>
                    <input
                      v-model="lot.winner_lot_specification.hy"
                      name="name"
                      type="text"
                      class="form-control"
                    >
                  </td>
                  <td>
                    <input
                      v-model="lot.winner_lot_specification.ru"
                      name="name"
                      type="text"
                      class="form-control"
                    >
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button :disabled="isLoading" @click="save" class="btn btn-sm btn-light mr-3">
        <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Պահպանել
      </button>
    </div>
  </modal>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import 'vue-date-pick/dist/vueDatePick.css';

  export default {
    name: 'WinnerLotsEditModal',
    components: {  },
    data() {
      return {
        isLoading: false,
        participantGroup: {},
      }
    },
    validations() {
      const rules = {
        participantGroup: {
          won_lots: {
            $each: {
              winner_lot_specification: {
                hy: {required},
                ru: {required}
              },
            }
          },
        },
      }
      return rules
    },
    computed: {
      currentOrganized() {
        return this.$store.getters['organize/currentOrganized']
      },
    },
    methods: {
      consoleLog(msg) {
        console.log(msg)
      },
      handleBeforeOpen({params}) {
        console.log(this.currentOrganized.cpv_type)
        this.participantGroup = params
        this.participantGroup.won_lots.forEach((lot) => {
          lot.winner_lot_cpv_code = lot.is_from_outside ? lot.procurement_plan.cpv_outside.code : lot.procurement_plan.cpv.code
          lot.winner_lot_cpv_name = lot.is_from_outside ? lot.procurement_plan.cpv_outside.name : lot.procurement_plan.cpv.name
          if(lot.winner_lot_specification === null || lot.winner_lot_specification === ''){
            lot.winner_lot_specification = {
              hy: lot.procurement_plan.specifications.description.hy,
              ru: lot.procurement_plan.specifications.description.ru,
            }
          } else {
            lot.winner_lot_specification = JSON.parse(lot.winner_lot_specification)
          }
          this.participantGroup.lots.push(lot);
        })
        console.log(this.participantGroup.lots)
      },
      save() {
        if(!this.$v.participantGroup.$invalid) {
          this.success = true;
          this.isLoading = true;
          this.participantGroup.won_lots.forEach((lot) => {
            const updateData = {  
              winner_lot_cpv_name : lot.winner_lot_cpv_name,
              winner_lot_trademark: lot.winner_lot_trademark,
              winner_lot_brand: lot.winner_lot_brand,
              winner_lot_manufacturer: lot.winner_lot_manufacturer,
              winner_lot_specification: JSON.stringify(lot.winner_lot_specification),
            }
            $client.put(`organize-row/${lot.id}`,updateData).then(response => {
              this.isLoading = false
            }).catch(e => {
              this.$notify({
                group: 'foo',
                type: 'error',
                title: 'Ինչ որ բան այն չէ',
                text: 'Կրկին փորձեք!'
              })
              this.success = false
              this.isLoading = false
            })
          })
          if(this.success){
            this.$notify({
              group: 'foo',
              type: 'success',
              text: 'Հաջողությամբ պահպանված է'
            })
            // this.$modal.hide('winner-lots-edit')
          }
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք տեխնիկական բնութագիրները պահպանելու համար!'
          })
        }
      }
    },
  }
</script>

<style scoped>
 .date-picker {
    display: block;
    width: 100%;
    border: 1px solid #e8ebf3;
    border-radius: .25rem;
    border-bottom: 1px solid #e8ebf3;
  }
  /deep/ .vdpWithInput > input {
    width: 100%;
    height: calc(1.8em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .845rem;
    font-weight: 400;
    line-height: 1.8;
    color: #303e67;
    border: none;
  }
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    width: 1200px !important;
    position: absolute;
    right: 0 !important;;
    left: 0 !important;;
    margin: auto;
    height: 80% !important;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>